import sendCommand from './base';
const playSound = ({ soundsetName, action }) => {
    return sendCommand({
        command: 'sound',
        params: {
            soundsetName,
            action,
        },
    });
};
const playDropdownSound = () => {
    return playSound({
        soundsetName: 'dropmenu_button',
        action: 'click',
    });
};
const playOpenDialogSound = () => {
    return playSound({
        soundsetName: 'default_window',
        action: 'open',
    });
};
const playCloseDialogSound = () => {
    return playSound({
        soundsetName: 'default_window',
        action: 'close',
    });
};
const playInputSound = () => {
    return playSound({
        soundsetName: 'default_textinput',
        action: 'change',
    });
};
const playCheckboxSound = () => {
    return playSound({
        soundsetName: 'default_checkbox',
        action: 'click',
    });
};
const playButtonSound = () => {
    return playSound({
        soundsetName: 'default_button',
        action: 'press',
    });
};
const playProgressBarSectionOpenSound = () => {
    return playSound({
        soundsetName: 'default_progress_bar',
        action: 'press',
    });
};
const playBoosterWindowOpen = () => {
    return playSound({
        soundsetName: 'default_window_buster',
        action: 'open',
    });
};
const playBoosterBuyRegular = () => {
    return playSound({
        soundsetName: 'default_booster',
        action: 'buy',
    });
};
const playBoosterPressRegular = () => {
    return playSound({
        soundsetName: 'default_booster',
        action: 'press',
    });
};
const playBoosterBuyPremium = () => {
    return playSound({
        soundsetName: 'default_prem_booster',
        action: 'buy',
    });
};
const playBoosterPressPremium = () => {
    return playSound({
        soundsetName: 'default_prem_booster',
        action: 'press',
    });
};
const playShipBuildAnimationStart = () => {
    return playSound({
        soundsetName: 'default_build_ship',
        action: 'start',
    });
};
const playShipBuildAnimationEnd = () => {
    return playSound({
        soundsetName: 'default_build_ship',
        action: 'end',
    });
};
const playBoosterBuildAnimationStart = () => {
    return playSound({
        soundsetName: 'default_build_building',
        action: 'start',
    });
};
const playBoosterBuildAnimationEnd = () => {
    return playSound({
        soundsetName: 'default_build_building',
        action: 'end',
    });
};
const playShipYardOver = () => {
    return playSound({
        soundsetName: 'default_shipyard_over',
        action: 'over',
    });
};
const playShipYardSoftOver = () => {
    return playSound({
        soundsetName: 'default_shipyard_over',
        action: 'soft_over',
    });
};
const playBuyoutOver = () => {
    return playSound({
        soundsetName: 'default_ship_buyout',
        action: 'over',
    });
};
const playBuyoutOut = () => {
    return playSound({
        soundsetName: 'default_ship_buyout',
        action: 'out',
    });
};
const shipyardSoundOn = () => {
    return playSound({
        soundsetName: 'default_shipyard_sound',
        action: 'on',
    });
};
const shipyardSoundOff = () => {
    return playSound({
        soundsetName: 'default_shipyard_sound',
        action: 'off',
    });
};
const changeShipyardStage = () => {
    return playSound({
        soundsetName: 'default_shipyard_stage',
        action: 'change',
    });
};
const sounds = {
    playSound,
    playDropdownSound,
    playOpenDialogSound,
    playCloseDialogSound,
    playInputSound,
    playCheckboxSound,
    playButtonSound,
    playProgressBarSectionOpenSound,
    playBoosterWindowOpen,
    playBoosterBuyRegular,
    playBoosterBuyPremium,
    playShipBuildAnimationStart,
    playShipBuildAnimationEnd,
    playBoosterBuildAnimationStart,
    playBoosterBuildAnimationEnd,
    playBoosterPressRegular,
    playBoosterPressPremium,
    playShipYardOver,
    playShipYardSoftOver,
    playBuyoutOver,
    playBuyoutOut,
    shipyardSoundOn,
    shipyardSoundOff,
    changeShipyardStage,
};
export default sounds;
